import React from 'react';
import { CustomerShippingAddressContract } from '../../../types/Customer';
import { AddressFormData } from '../../../types/Address';
import { SectionSummaryGroupPosition } from '../../summary/SectionSummary';
import ShipToSummary from '../../summary/ShipToSummary';

type EditableShippingAddressSectionProps = {
  disableActionButton?: boolean;
  disallowEdit?: never;
  toolTipText?: string;
  onShipToInfoEdit: () => void;
};

type ReadOnlyShippingAddressSectionProps = {
  disallowEdit: true;
  onShipToInfoEdit?: never;
  disableActionButton?: false;
};

export type AuthenticatedShippingAddressSectionBaseProps = {
  shippingAddress: CustomerShippingAddressContract | null;
  toolTipKey: string;
  groupPosition?: SectionSummaryGroupPosition;
  toolTipText?: string;
};

export type AuthenticatedShippingAddressSectionProps =
  AuthenticatedShippingAddressSectionBaseProps &
    (EditableShippingAddressSectionProps | ReadOnlyShippingAddressSectionProps);

const AuthenticatedShippingAddressSection: React.FC<
  AuthenticatedShippingAddressSectionProps
> = ({
  disallowEdit,
  disableActionButton,
  shippingAddress,
  groupPosition,
  toolTipText,
  toolTipKey,
  onShipToInfoEdit,
}: AuthenticatedShippingAddressSectionProps) => {
  return disallowEdit ? (
    <ShipToSummary
      address={shippingAddress as AddressFormData}
      disallowEdit
      groupPosition={groupPosition}
      toolTipKey={toolTipKey}
    />
  ) : (
    <ShipToSummary
      address={shippingAddress as AddressFormData}
      onEditClicked={onShipToInfoEdit}
      groupPosition={groupPosition}
      disableActionButton={disableActionButton}
      toolTipText={toolTipText}
      toolTipKey={toolTipKey}
    />
  );
};

export default AuthenticatedShippingAddressSection;
